import { Wallet, CreditCard, ExternalLink, FileText, ShieldCheck } from 'lucide-react';

export const WalletWidget = ({ wallet, onShowPricing }) => {
  if (!wallet) return null;

  const isSA = wallet.is_super_admin;
  const isBlocked = !isSA && wallet.balance <= 0;
  const isLow = !isSA && wallet.balance > 0 && wallet.balance <= wallet.alert_threshold;

  return (
    <div className={`flex items-center gap-4 p-4 rounded-xl border-2 flex-wrap ${
      isSA ? 'bg-teal-50 border-teal-200' :
      isBlocked ? 'bg-red-50 border-red-300' :
      isLow ? 'bg-amber-50 border-amber-300' :
      'bg-emerald-50 border-emerald-200'
    }`} data-testid="risk-wallet-widget">
      <div className="flex items-center gap-2">
        <Wallet className={`w-5 h-5 ${isSA ? 'text-teal-600' : isBlocked ? 'text-red-600' : isLow ? 'text-amber-600' : 'text-emerald-600'}`} />
        <span className="text-sm font-medium text-slate-700">Credito API CALLS TelcaVoIP AI:</span>
      </div>
      <span className={`text-xl font-bold ${isSA ? 'text-teal-700' : isBlocked ? 'text-red-700' : isLow ? 'text-amber-700' : 'text-emerald-700'}`}>
        {wallet.balance.toFixed(2)}€
      </span>
      {isSA && (
        <span className="inline-flex items-center gap-1 text-xs font-semibold text-teal-700 bg-teal-100 px-2 py-0.5 rounded-full">
          <ShieldCheck className="w-3 h-3" /> SUPER ADMIN — SERVIZIO SEMPRE ATTIVO
        </span>
      )}
      {isBlocked && (
        <span className="text-xs font-semibold text-red-600 bg-red-100 px-2 py-0.5 rounded-full">SERVIZIO BLOCCATO</span>
      )}
      {isLow && (
        <span className="text-xs font-semibold text-amber-600 bg-amber-100 px-2 py-0.5 rounded-full">CREDITO BASSO</span>
      )}
      <div className="ml-auto flex items-center gap-3">
        {isSA && (
          <span className="text-xs text-slate-500">Maggiorazione: {wallet.markup_pct}%</span>
        )}
        <button onClick={onShowPricing}
          className="inline-flex items-center gap-1.5 px-3 py-2 bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 text-xs font-medium rounded-lg transition-all"
          data-testid="risk-pricing-btn">
          <FileText className="w-3.5 h-3.5 text-teal-600" />
          Verifica costi servizi TelcaVoIP AI RISK
        </button>
        {!isSA && (
          <a href="https://telcavoip.ai/it/api-recharge" target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-teal-500 to-cyan-600 hover:from-teal-600 hover:to-cyan-700 text-white text-sm font-semibold rounded-lg shadow-sm transition-all hover:shadow-md"
            data-testid="risk-recharge-cta">
            <CreditCard className="w-4 h-4" />
            Ricarica Credito
            <ExternalLink className="w-3 h-3 ml-0.5 opacity-70" />
          </a>
        )}
      </div>
    </div>
  );
};
